<template>
  <div class="send-medici-container">
    <!-- 顶部区域 -->
    <div class="send-medici-header">
		<i class="el-icon-xy" style="border-radius: 50%;font-size: 20px;padding: 6px;margin-left: 8px;;background-color: #00aa00;color: #fff;"></i>
		<h4 style="margin-left: 12px;">中药房门诊发药</h4>
    </div>
    
    <!-- 主体区域 -->
    <div class="send-medici-main">
      <!-- 左侧区域 (20%宽度) -->
      <div class="send-medici-left">
        <!-- 左侧上部表单 -->
        <div class="left-form">
          <el-form label-position="left" size="small">
            <el-form-item label="药房名称">
              <el-select v-model="form.pharmacyName" placeholder="请选择药房">
                <el-option label="中药房" value="中药房"></el-option>
              </el-select>
            </el-form-item>
                  
			  <el-form-item>
				<div class="form-item-row">
				  <span class="form-label">健康ID</span>
				  <el-input v-model="form.healthId" placeholder="请输入健康ID"></el-input>
				</div>
			  </el-form-item>
			  
			  <el-form-item>
				<div class="form-item-row">
				  <span class="form-label">处方查找</span>
				  <el-input v-model="form.prescriptionSearch" placeholder="处方编号"></el-input>
				</div>
			  </el-form-item>
			  
			  <el-form-item>
				<div class="form-item-row">
				  <span class="form-label">患者姓名</span>
					<el-input v-model="form.name" placeholder="姓名/拼音简码" clearable></el-input>
					<el-button 
                      type="primary" 
                      size="small" 
                      style="margin-left: 10px; padding: 6px 8px;" 
                      :loading="loading" 
                      @click="getUserInfo"
                    >
                      <i class="el-icon-Ssearch">查询</i>
                    </el-button>
				</div>
			  </el-form-item>
			  
			  <el-form-item>
				<div class="form-item-row">
				  <span class="form-label">刷新时长</span>
				  <el-input 
                    v-model="form.refreshTime" 
                    placeholder="秒" 
                    style="width: 60px;"
                    :disabled="true"
                    value="5"
                  ></el-input>
				  <el-checkbox v-model="form.showBatch" style="margin-left: 10px;">显示药品批次</el-checkbox>
				</div>
			  </el-form-item>
			</el-form>
        </div>
        
        <!-- 左侧下部表格 -->
        <div class="left-table-container">
          <el-table
            :data="leftTableData"
            border
            style="width: 100%"
            :height="leftTableHeight"
			@row-dblclick="getDataValue"
            size="small"
            class="left-table"
          >
            <el-table-column type="index" label="行号" width="48"></el-table-column>
            <el-table-column prop="name" label="病人姓名" width="88"></el-table-column>
            <el-table-column prop="age" label="年龄" width="60"></el-table-column>
			<el-table-column prop="sex" sortable label="性别" width="80">
			  <template slot-scope="scope">
			    <span>
			      <i :class="scope.row.sex === 1? 'el-icon-male' : 'el-icon-female'" 
			          :style="{color: scope.row.sex === 1 ? '#409EFF' : '#F56C6C'}"></i>
			      {{ scope.row.sex === 1 ? '男' : '女' }}
			    </span>
			  </template>
			</el-table-column>
			<el-table-column prop="patientId" label="健康id" width="80"></el-table-column>
			<el-table-column prop="cardId" label="身份证号码" width="188"></el-table-column>
			<el-table-column prop="fullName" label="处方医生" width="100"></el-table-column>
			<el-table-column prop="state" label="状态">
				<template slot-scope="{ row }">
					<!-- 根据state显示不同的图标 -->
					<div class="stateValue" style="border-radius: 4px;background-color: #e2fff6;text-align: center;color: #004a00;">
						<i :class="statusIconMap[row.state]" :style="{ color: statusColorMap[row.state] }"></i>
						<span>{{ statusMap[row.state] || '未知状态' }}</span>
					</div>
				</template>
			</el-table-column>
            <el-table-column prop="remark" label="备注" width="80"></el-table-column>
          </el-table>
          
          <!-- 左侧分页 -->
          <div class="left-pagination">
            <el-pagination
              @size-change="handleLeftSizeChange"
              @current-change="handleLeftCurrentChange"
              :current-page="leftPageNum"
              :page-sizes="[8, 15, 30, 50]"
              :page-size="leftPageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="leftTotal"
              small
            />
          </div>
        </div>
      </div>
      
      <!-- 右侧区域 (80%宽度) -->
      <div class="send-medici-right">
        <!-- 右侧上部描述列表 -->
        <div class="right-descriptions">
          <el-descriptions 
            title="" 
            border 
            :column="5" 
            size="small"
            class="custom-descriptions"
          >
            <el-descriptions-item label="处方编号">
              <el-tag size="small">{{ rightForm.rxNo || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="病员姓名">
              <el-tag size="small">{{ rightForm.name || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="身份证号">
              <el-tag size="small">{{ rightForm.cardId || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="性别">
              <el-tag size="small" :type="rightForm.sex === 1 ? 'primary' : 'danger'">
                {{ rightForm.sex === 1 ? '男' : '女' }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="年龄">
              <el-tag size="small">{{ rightForm.age || 0 }}岁</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="健康ID">
              <el-tag size="small">{{ rightForm.patientId || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方科室">
              <el-tag size="small">{{ rightForm.deptName || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方医生">
              <el-tag size="small">{{ rightForm.fullName || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方金额">
              <el-tag size="small" type="danger">￥{{ formatCurrency(rightForm.saleAmt || 0) }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方类型">
              <el-tag size="small">{{ rightForm.rxName || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="皮试处方">
              <el-tag size="small" :type="rightForm.skintstRx === 1 ? 'danger' : 'info'">
                {{ rightForm.skintstRx === 1 ? '是' : '否' }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="代办人">
              <el-tag size="small">{{ rightForm.agnterName || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="代办人身份证">
              <el-tag size="small">{{ rightForm.agnterCretno || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="中医诊断">
              <el-tag size="small">{{ rightForm.westernDiagnos || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="状态">
              <el-tag 
                size="small" 
                :type="getStatusType(rightForm.state)"
              >
                {{ getStatusText(rightForm.state) }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="其它信息">
              <el-tag size="small">{{ rightForm.otherInfo || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="备注" :span="3">
              <span class="remark-text">{{ rightForm.remark || '-' }}</span>
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 右侧下部表格 -->
        <div class="right-table-container">
          <el-table
            ref="rightTable"
            :data="rightTableData"
            border
            style="width: 100%"
            :height="rightTableHeight"
            size="small"
            show-summary
            :summary-method="getSummaries"
            class="right-table"
          >
            <el-table-column type="index" label="行号" width="60"></el-table-column>
            <el-table-column prop="name" label="药品名称" width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="drugSpec" label="药品规格" width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="cnt" label="数量" width="80" align="right">
              <template slot-scope="{ row }">
                {{ row.cnt || 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="unt" label="单位" width="60"></el-table-column>
            <el-table-column prop="usedFrquName" label="用法" width="120"></el-table-column>
            <el-table-column prop="tcmWayName" label="频次" width="100"></el-table-column>

            <el-table-column prop="purcPric" label="单价" width="80" align="right">
              <template slot-scope="{ row }">
                {{ formatCurrency(row.purcPric || 0) }}
              </template>
            </el-table-column>
            <el-table-column prop="saleAmt" label="金额" width="80" align="right">
              <template slot-scope="{ row }">
                {{ formatCurrency(row.saleAmt || 0) }}
              </template>
            </el-table-column>
            <el-table-column prop="manuLotnum" label="批号" width="100"></el-table-column>
            <el-table-column prop="expyDate" label="有效期" width="120">
              <template slot-scope="{ row }">
                {{ row.expyDate || '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="prodentpName" label="生产厂家" width="150" show-overflow-tooltip></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    
    <!-- 底部区域 (100%宽度) -->
    <!-- 底部按钮区域 -->
    <div class="send-medici-bottom">
      <div class="bottom-left">
        <el-button 
          :loading="buttonLoading.print" 
          type="warning" 
          size="small"
          :disabled="true"
        >
          打印
        </el-button>
        <el-checkbox 
          v-model="closeAfterPrint" 
          style="margin-left: 10px;"
          :disabled="true"
        >
          自动打印
        </el-checkbox>
      </div>
      <div class="bottom-right">
		  
		  <el-button 
		    :loading="buttonLoading.sendMedic" 
		    type="success" 
		    size="small" 
			icon="el-icon-quyaoput"
		    @click="sendMedic"
		  >
		    发药
		  </el-button>
		  
        <el-button 
          :loading="buttonLoading.callPatient" 
          type="primary" 
          size="small"
          :disabled="true"
        >
          呼叫患者
        </el-button>
        <el-button 
          :loading="buttonLoading.skipNumber" 
          type="primary" 
          size="small"
          :disabled="true"
        >
          一键过号
        </el-button>
        <el-button 
          :loading="buttonLoading.refund" 
          type="primary" 
          size="small"
          :disabled="true"
        >
          许可退费
        </el-button>
        <el-button 
          :loading="buttonLoading.printPrescription" 
          type="primary" 
          size="small"
          :disabled="true"
        >
          打印处方
        </el-button>
        <el-button 
          :loading="buttonLoading.batchDispense" 
          type="primary" 
          size="small"
          :disabled="true"
        >
          批量发药
        </el-button>
      </div>
    </div>
	
	<!-- 完成发药对话框 -->
	  <el-dialog
	    :visible.sync="sendMedicineDialogVisible"
	    title="完成发药"
	    width="500px"
	    :before-close="handleSendMedicineClose"
	    class="send-medicine-dialog"
	  >
	    <div class="send-medicine-content">
	      <div class="info-item">
	        <span class="label">患者</span>
	        <span class="value">{{ sendMedicineData.patientName || '匿名患者' }}</span>
	      </div>
	      <div class="info-item">
	        <span class="label">诊断</span>
	        <span class="value">{{ sendMedicineData.diagnosis || '无诊断信息' }}</span>
	      </div>
	      <div class="info-item">
			  <span class="label">发药内容</span>
			  <div class="medicine-content">
				<el-link 
				  type="primary" 
				  @click="openTraceCodeDialog"
				  class="trace-code-link"
				>
				  追溯码（{{ sendMedicineData.traceCodeCount || 0 }}）
				</el-link>
				<div class="medicine-type" @click="toggleMedicineList">
				  <span>中中成药（{{ sendMedicineData.medicineCount || 0 }}种）</span>
				  <i :class="showMedicineList ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" style="margin-left: 8px;"></i>
				</div>
				
				<!-- 药品列表部分 -->
				<div 
				  class="medicine-list" 
				  :class="{ 'expanded': showMedicineList }"
				  :style="{ 'max-height': showMedicineList ? medicineListMaxHeight : '0' }"
				>
				  <div 
				    class="medicine-item" 
				    v-for="(item, index) in westernMedicines" 
				    :key="index"
				  >
				    <!-- 完成发药对话框中的药品列表样式修改 -->

				      <span class="medicine-name" :style="{ 
				        color: item.drugTracB === 1 ? 
				          (item.traceCodeCollected ? '#67C23A' : '#F56C6C') 
				          : 'inherit' 
				      }">
				        {{ item.name }}
				      </span>
				    <el-tag type="info" size="mini" style="margin-left: 8px;">中药</el-tag>
				    <span v-if="item.drugTracB === 1" style="margin-left: 10px;">
				      <span v-if="item.traceCodeCollected" style="color: #67C23A">
				        已录入追溯码 ({{ item.drgTracCnt }}个)
				      </span>
				      <span v-else style="color: #F56C6C">
				        该药品已强制要求追溯码，请先录入再进行发药！
				      </span>
				    </span>
				  </div>
				</div>
			  </div>
			</div>
		  </div>
	    
	    <div class="dialog-footer">
	      <el-checkbox v-model="sendMedicineData.printTogether">同时打印</el-checkbox>
	      <div class="footer-buttons">
	        <el-button size="mini" @click="sendMedicineDialogVisible = false">取消</el-button>
	        <!-- 发药对话框的确定按钮 -->
	        <el-button 
	          size="mini" 
	          type="primary" 
	          @click="confirmSendMedicine"
	          :disabled="hasUncollectedMandatoryTrace"
	        >
	          确定
	        </el-button>
	      </div>
	    </div>
	  </el-dialog>
	
	  <!-- 追溯码采集对话框 -->
	    <el-dialog
	      :visible.sync="traceCodeDialogVisible"
	      title="追溯码采集"
	      width="800px"
	      :before-close="handleTraceCodeClose"
	      class="trace-code-dialog"
	    >
	      <div class="trace-code-content">
	        <!-- 重要提醒 -->
	        <div class="important-reminder">
	          <div class="reminder-header">
	            <i class="el-icon-warning"></i>
	            <span>依码支付重要提醒</span>
	          </div>
	          <div class="reminder-content">
	            <p>1.请根据实际情况调整"整""零"发药数量（如：某药10支/盒，发药2盒，其中整装1盒，另1盒是拆零凑成，则将"整"调整为1盒）。</p>
	            <p>2.如果无法修改"整装"数量，请退费重新收费，在医保结算窗口进行调整。</p>
	          </div>
	        </div>
	    
	        <!-- 扫描输入区域 -->
	        <div class="scan-input-area">
	          <el-input
	            v-model="traceCodeInput"
	            placeholder="扫描或输入追溯码"
	            clearable
	            class="trace-code-input"
				:disabled="true"
	          >
	            <template slot="append">
	              <el-button icon="el-icon-search" @click="openScanDialog">扫描</el-button>
	            </template>
	          </el-input>
	          <div class="input-tips">
	            <el-link type="primary">发药项目无追溯码？</el-link>
	            <el-link type="primary">如何判断拆零？</el-link>
	          </div>
	        </div>
	    
	        <!-- 发药项目表格 -->
	        <el-table
			:data="traceCodeTableData"
			border
			style="width: 100%; margin-top: 16px"
			class="trace-code-table"
			>
	          <el-table-column prop="medicineName" label="待发药项目" width="200">
	            <template slot-scope="scope">
	              {{ scope.row.medicineName }}
	            </template>
	          </el-table-column>
	          <el-table-column prop="productCode" label="生产厂家" width="188">
	            <template slot-scope="scope">
	              {{ scope.row.productCode }}
	            </template>
	          </el-table-column>
	          <el-table-column prop="sendStatus" label="发药" width="80">
	            <template slot-scope="scope">
	              <el-tag :type="scope.row.sendStatus === '已关联' ? 'success' : 'warning'">
	                {{ scope.row.sendStatus }}
	              </el-tag>
	            </template>
	          </el-table-column>
	          <el-table-column prop="sendCombo" label="发药组合" width="100">
	            <template slot-scope="scope">
	              {{ scope.row.sendCombo }}
	            </template>
	          </el-table-column>
	          <el-table-column prop="drgTracCnt" label="追溯码扫码数量" width="120">
	            <template slot-scope="scope">
	              {{ scope.row.drgTracCnt }}
	            </template>
	          </el-table-column>
	          <el-table-column prop="drgTracCode" label="追溯码" width="188">
	                <template slot-scope="scope">
	                  <!-- 显示已绑定的追溯码 -->
	                  <span v-if="scope.row.drgTracCode">{{ scope.row.drgTracCode }}</span>
	                  <span v-else class="no-trace-code">未对码药品无需采集</span>
	                </template>
	              </el-table-column>

	        </el-table>
	      </div>
	    
	      <div slot="footer" class="trace-code-footer">
	        <!-- 追溯码采集对话框的完成按钮 -->
	        <el-button 
	          type="primary" 
	          @click="completeTraceCode"
	          :disabled="!isTraceCodeComplete"
	        >
	          完成
	        </el-button>
	        <!-- <el-button @click="saveTemporary">暂存</el-button> -->
	        <el-button @click="traceCodeDialogVisible = false">取消</el-button>
	      </div>
	    </el-dialog>
	  
	  <!-- 追溯码扫码录入弹框 -->
	    <el-dialog
	      :visible.sync="scanDialogVisible"
	      title="追溯码扫码录入"
	      width="600px"
	      class="scan-dialog"
	      :close-on-click-modal="false"
	    >
	      <div class="scan-container">
	        <div class="scan-header">
	          <i class="el-icon-camera"></i>
	          <span>请扫描药品追溯码</span>
	        </div>
	        
	        <div class="scan-preview">
	          <div class="scan-frame">
	            <div class="scan-line"></div>
	          </div>
	        </div>
	        
	        <div class="scan-input-area">
	          <el-input
	            v-model="scanInput"
	            placeholder="手动输入追溯码"
	            clearable
	            @keyup.enter.native="handleScanInput"
	          >
	            <template slot="append">
	              <el-button 
	                type="primary" 
	                @click="handleScanInput"
	                :disabled="!scanInput"
	              >
	                确认
	              </el-button>
	            </template>
	          </el-input>
	        </div>
	        
	        <div class="scan-tips">
	          <p><i class="el-icon-info"></i> 请将药品追溯码对准扫描框中心</p>
	          <p><i class="el-icon-info"></i> 扫码后请核对药品信息</p>
	        </div>
	        
	        <!-- 新增：匹配药品信息表格 -->
	        <div class="matched-medicines" v-if="matchedMedicines.length > 0">
	          <el-table
	            :data="matchedMedicines"
	            border
	            style="width: 100%; margin-top: 16px"
	            max-height="200"
	          >
	            <el-table-column prop="name" label="药品名称" width="150"></el-table-column>
	            <el-table-column prop="drugSpec" label="规格" width="120"></el-table-column>
	            <el-table-column label="追溯标识码">
	              <template slot-scope="scope">
	                {{ traceCodePrefix }}
	              </template>
	            </el-table-column>
	            <el-table-column label="完整追溯码" width="188">
	              <template slot-scope="scope">
	                {{ scanInput }}
	              </template>
	            </el-table-column>
	          </el-table>

	        </div>
	      </div>
	      
	      <div slot="footer" class="scan-footer">
	          <!-- 修改确认绑定按钮 -->
	          <el-button
	            type="primary" 
	            size="small"
	            @click="confirmTraceCode"
	            :disabled="matchedMedicines.length === 0"
	          >
	            确认绑定
	          </el-button>
	          <el-button size="small" @click="scanDialogVisible = false">取消</el-button>
	        </div>
	  </el-dialog>
	  <!-- 新增：发药进度条对话框 -->
	  <el-dialog
	    :visible.sync="progressDialogVisible"
	    title="发药进度"
	    width="600px"
	    :close-on-click-modal="false"
	    :close-on-press-escape="false"
	    :show-close="false"
	    class="progress-dialog"
	  >
	    <div class="progress-container">
	      <el-steps :active="progressStep" align-center>
	        <el-step title="检查追溯码" :description="progressStep1Desc"></el-step>
	        <el-step title="执行发药" :description="progressStep2Desc"></el-step>
	        <el-step title="上传医保" :description="progressStep3Desc"></el-step>
	      </el-steps>
	      
	      <div class="progress-details" v-if="progressDetails.length > 0">
	        <div class="details-title">执行详情：</div>
	        <div class="details-content">
	          <div v-for="(detail, index) in progressDetails" :key="index" class="detail-item">
	            <i :class="detail.type === 'success' ? 'el-icon-success success-icon' : 
	                       detail.type === 'error' ? 'el-icon-error error-icon' : 
	                       'el-icon-info info-icon'"></i>
	            <span>{{ detail.message }}</span>
	          </div>
	        </div>
	      </div>
	    </div>
	    
	    <!-- 进度条对话框的footer -->
	    <div slot="footer" class="progress-footer">
	      <el-button 
	        v-if="progressStep === 3 && !progressHasError" 
	        type="primary" 
	        @click="handleProgressComplete"
	      >
	        完成
	      </el-button>
	      <el-button 
	        v-if="progressHasError" 
	        type="danger" 
	        @click="progressDialogVisible = false"
	      >
	        关闭
	      </el-button>
	      <el-button 
	        v-if="progressStep < 3 && !progressHasError" 
	        :loading="progressLoading"
	        disabled
	      >
	        处理中...
	      </el-button>
	    </div>
	  </el-dialog>
	  
  </div>
</template>

<script>
// 接口
import { selectZYPatientInfo,fyZYSave } from "@/api/MedicenHouse/WesternGive.js";
// 新增：医保接口相关
// import {ybapi} from "/src/api/yb/ybApi.js"
import { getChs, addInfYB, getlyId } from "@/api/yb/yb-api.js"; // 古
import { 
  sendYbRequest, 
  buildYbRequest, 
  generateYbHeaders,
  getUserInfo as getYbUserInfo
} from "@/api/yb/ybApi.js";
import {addYbRquestData, getqdNo, toUploadLY ,changeYB} from "@/api/yb";
// others - tool
import dayjs from "dayjs";

import { toYb3505 } from "@/api/yb/yb-api.js";

export default {
  name: 'SendMedici',
  
	// 计算属性
    computed: {
	// 正确检测未采集的强制追溯码药品
	hasUncollectedMandatoryTrace() {
	  const result = this.westernMedicines.some(item => 
		item.drugTracB === 1 && 
		(!item.traceCodeCollected || !item.drgTracCode || item.drgTracCode.trim() === '')
	  );
	  
	  console.log('hasUncollectedMandatoryTrace:', result);
	  console.log('Western Medicines:', this.westernMedicines);
	  
	  return result;
	},
      
      // 检查追溯码是否采集完成
      isTraceCodeComplete() {
        return this.traceCodeTableData.every(item => {
          // 只需要检查强制追溯码药品
          if (item.rawData && item.rawData.drugTracB === 1) {
            return !!item.drgTracCode && item.drgTracCode.trim() !== '';
          }
          return true; // 非强制追溯码药品直接通过
        });
      },
      
      medicineListMaxHeight() {
        if (!this.westernMedicines || this.westernMedicines.length === 0) return '0';
        
        const itemHeight = 40;
        const maxVisibleItems = 5;
        const calculatedHeight = Math.min(this.westernMedicines.length, maxVisibleItems) * itemHeight;
        
        return `${calculatedHeight}px`;
      }
    },
  
  data() {
    return {
		searchedValue:'', // 患者姓名
		patientId:'', // 健康ID
		rxNoValue:'', // 处方编码
		// 新增扫码对话框相关数据
		scanDialogVisible: false,
		scanInput: '',
		currentScanItem: null,
		// blean
		loading:false,
		sexOptions:[{id:1,label:'男',value:'男'},{id:2,label:'女',value:'女'}],
		YNOption:[{id:0,label:'否'},{id:1,label:'是'}],//库房
      form: {
        pharmacyName: '中药房',
        healthId: '',
        prescriptionSearch: '',
        name: '',
        refreshTime: '5', // 默认5秒
        showBatch: true
      },
      // 左侧表格分页
      leftPageNum: 1,
      leftPageSize: 8,
      leftTotal: 0,
      
	  // 发药对话框相关数据
	sendMedicineDialogVisible: false,
	sendMedicineData: {
	  patientName: '',
	  diagnosis: '',
	  traceCodeCount: 0,
	  medicineCount: 0,
	  printTogether: false
	},
	// 新增：进度条相关数据
	progressDialogVisible: false,
	progressStep: 0,
	progressStep1Desc: '等待检查',
	progressStep2Desc: '等待执行',
	progressStep3Desc: '等待上传',
	progressDetails: [],
	progressLoading: false,
	progressHasError: false,
	
	// 追溯码对话框相关数据
	traceCodeDialogVisible: false,
	traceCodeInput: '',
	traceCodeTableData: [
	  {
		medicineName: '小柴胡汤丸 8g*9袋/盒',
		productCode: '朗致集团万荣',
		sendStatus: '未关联',
		sendCombo: '2盒',
		drgTracCnt: '2盒',
		drgTracCode: ''
	  }
	],
	  showMedicineList: false, // 是否显示药品列表
	  westernMedicines: [], // 中药列表
	  timer: null, // 5秒刷新定时器
	  buttonLoading: { // 各按钮的加载状态
		print: false,
		callPatient: false,
		skipNumber: false,
		refund: false,
		printPrescription: false,
		batchDispense: false,
		sendMedic: false
	  },
      rightForm: {
			"age": 0,
			"agnterCretno": "",
			"agnterName": "",
			"cardId": "",
			"deptName": "",
			"fullName": "",
			"westernDiagnos": "",
			"id": 0,
			"name": "",
			"patientId": 0,
			"remark": "",
			"rxName": "",
			"rxNo": 0,
			"saleAmt": 0,
			"sex": 0,
			"skintstRx": 0,
			"state": 0,
			"voList": [
				{
					"cnt": 0,
					"dosform": "",
					"drugId": 0,
					"drgTracCnt":"",
					"name": "",
					"drgTracCode": "",
					"drugSpec": "",
					"dugPurcId": 0,
					"expyDate": "",
					"tcmWayName": "",
					"manuLotnum": "",
					"maxPurcPric": 0,
					"maxSalePric": 0,
					"minPurcPric": 0,
					"minSalePric": 0,
					"pacCnt": 0,
					"prdDays": 0,
					"prodentpName": "",
					"prodentpNameId": 0,
					"purcAmt": 0,
					"purcPric": 0,
					"purcType": "",
					"rdDetailsId": 0,
					"rxId": 0,
					"saleAmt": 0,
					"salePric": 0,
					"saleUnt": 0,
					"supplyCandidateId": 0,
					"unt": "",
					"usedFrquName": "",
					"drugTracB":0,
					"drugTracMaxCnt":'',
					"drugTracMaxId":'',
					"drugTracMinId":'',
				}
			]
      },
      leftTableData: [],
	  detailsVo: [],
      rightTableData: [],
	  // props
	  statusMap: {
	  	0: '草稿',
	  	1: '已收费',
	  	2: '已配药',
	  	3: '已发药',
	  	4: '已退药'
	  },
	  statusIconMap: {
	  	0: 'el-icon-document',
	  	1: 'el-icon-top-left',
	  	2: 'el-icon-check',
	  	3: 'el-icon-bottom-right',
	  	4: 'el-icon-document-checked',
	  },
	  statusColorMap: {
	  	0: '#909399',
	  	1: '#67C23A',
	  	2: '#409EFF',
	  	3: '#E6A23C',
	  	4: '#F56C6C',
	  },
	  // 新增数据项
	  traceCodePrefix: '', // 追溯码前7位
	  matchedMedicines: [], // 匹配到的药品列表
      closeAfterPrint: true,
      leftTableHeight: 'calc(100vh - 200px)',
      rightTableHeight: 'calc(100vh - 350px)'
    }
  },
  mounted() {
	this.loadData();
    this.calculateTableHeights();
    window.addEventListener('resize', this.calculateTableHeights);
    
    // 启动5秒定时刷新
    this.startAutoRefresh();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateTableHeights);
    // 清除定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
	// 启动5秒自动刷新
    startAutoRefresh() {
      // 清除现有定时器
      if (this.timer) {
        clearInterval(this.timer);
      }
      
      // 设置5秒刷新
      this.timer = setInterval(() => {
        this.loadData();
      }, 5000);
    },
    
	async loadData(){
		this.loading = true;
		let res = await selectZYPatientInfo({
			name:this.searchedValue,
			patientId:this.patientId,
			rxNo:this.rxNoValue,
			pageNum: this.leftPageNum,
			pageSize: this.leftPageSize
		});
		if(res.code === 200){
			this.leftTableData = res.data.content || [];
			this.leftTotal = res.data.totalSize || 0;
			console.log(this.leftTableData,'leftTableDataleftTableData');
			this.loading = false;
		}else{
			this.leftTableData = [];
			this.leftTotal = 0;
			this.loading = false;
		}
	  },
	  // 左侧分页大小改变
	  handleLeftSizeChange(val) {
	    this.leftPageSize = val;
	    this.leftPageNum = 1;
	    this.loadData();
	  },
	  
	  // 左侧当前页改变
	  handleLeftCurrentChange(val) {
	    this.leftPageNum = val;
	    this.loadData();
	  },
	  
	  // 刷新按钮查询条件
	  getUserInfo(){
		this.searchedValue = this.form.name; // 患者姓名
		this.patientId = this.form.healthId; // 健康id
		this.rxNoValue = this.form.rxNoValue; // 处方查找
		this.leftPageNum = 1; // 重置到第一页
		this.loadData();
	  },
	
	// 修改后的发药流程控制方法
	async startSendMedicineProcess() {
	  // 打开进度对话框
	  this.progressDialogVisible = true;
	  this.progressStep = 0;
	  this.progressStep1Desc = '等待检查';
	  this.progressStep2Desc = '等待执行';
	  this.progressStep3Desc = '等待上传';
	  this.progressDetails = [];
	  this.progressHasError = false;
	  this.progressLoading = true;
	  
	  try {
		// 第一步：验证数据完整性
		await this.validateSendDataPreCheck();
	    // 第二步：检查追溯码
	    await this.checkTraceCodes();
	    
	    // 第3步：执行发药
	    const sendResult = await this.executeMedicineDispensing();
	    
	    // 第三步：根据用户类型决定是否上传医保
	    if (sendResult.success) {
	      if (sendResult.isInsurance) {
	        // 医保用户：调用医保接口
	        await this.uploadToMedicalInsurance();
	      } else {
	        // 非医保用户：直接完成流程
	        await this.handleNonInsuranceUser();
	      }
	    } else {
	      // 发药失败处理
	      this.addProgressDetail('发药失败', 'error');
	      this.progressHasError = true;
	      
	      // 根据用户类型决定是否尝试上传医保
	      if (sendResult.isInsurance) {
	        this.addProgressDetail('但仍尝试上传医保信息', 'warning');
	        await this.uploadToMedicalInsurance();
	      } else {
	        await this.handleNonInsuranceUser();
	      }
	    }
	    
	  } catch (error) {
	    console.error('发药流程异常:', error);
	    this.addProgressDetail(`发药流程异常: ${error.message}`, 'error');
	    this.progressHasError = true;
	  } finally {
	    this.progressLoading = false;
	    
	    // 如果流程完成且没有错误，设置自动关闭
	    if (this.progressStep === 3 && !this.progressHasError) {
	      setTimeout(() => {
	        this.progressDialogVisible = false;
	        this.$message.success('发药流程已完成');
	      }, 2000);
	    }
	  }
	},
	// 新增：发药前数据验证
	async validateSendDataPreCheck() {
	  this.progressStep = 0;
	  this.progressStep1Desc = '数据验证中...';
	  
	  // 检查是否有选中处方
	  if (!this.rightForm.id) {
	    throw new Error('未选择处方，请先双击选择处方');
	  }
	  
	  // 检查药品列表
	  if (!this.rightTableData || this.rightTableData.length === 0) {
	    throw new Error('处方中没有药品数据');
	  }
	  
	  // 检查强制追溯码药品
	  const mandatoryTraceDrugs = this.rightTableData.filter(item => item.drugTracB === 1);
	  const uncollectedDrugs = mandatoryTraceDrugs.filter(item => !item.drgTracCode || item.drgTracCode.trim() === '');
	  
	  if (uncollectedDrugs.length > 0) {
	    const drugNames = uncollectedDrugs.map(item => item.name || '未知药品').join('、');
	    throw new Error(`以下强制追溯码药品未采集追溯码: ${drugNames}`);
	  }
	  
	  this.addProgressDetail('数据验证通过', 'success');
	  this.progressStep1Desc = '数据验证完成';
	},
	// 处理非医保用户完成流程
	async handleNonInsuranceUser() {
	  this.progressStep = 3;
	  this.progressStep3Desc = '非医保用户，跳过上传';
	  
	  this.addProgressDetail('当前用户为非医保用户，无需调用医保接口', 'info');
	  this.addProgressDetail('发药流程已完成', 'success');
	  
	  // 立即刷新表格数据
	  await this.refreshTableData();
	  
	  // 设置进度完成状态
	  this.progressLoading = false;
	  
	  // 非医保用户：发药成功后直接关闭进度条并刷新数据
	  setTimeout(() => {
	    this.progressDialogVisible = false;
	    this.$message.success('发药成功');
	  }, 1000);
	},
	
	// 修改第三步：上传医保接口（增加医保用户判断）
	async uploadToMedicalInsurance() {
	  // 首先检查用户是否为医保用户
	  if (!this.checkUserInsuranceStatus()) {
	    this.addProgressDetail('当前用户为非医保用户，跳过医保接口调用', 'info');
	    this.progressStep3Desc = '非医保用户，跳过上传';
	    
	    // 非医保用户直接完成流程
	    await this.handleNonInsuranceUser();
	    return;
	  }
	  
	  this.progressStep = 3;
	  this.progressStep3Desc = '准备上传...';
	  
	  try {
	    this.addProgressDetail('正在准备上传医保3505（商品销售）接口', 'info');
	    this.progressStep3Desc = '上传中...';
	    
	    // 准备医保上传数据
	    const insuranceData = this.prepareInsuranceData();
	    
	    this.addProgressDetail('开始调用医保3505接口...', 'info');
	    
	    // 调用医保接口
	    const res = await this.toYb3505(insuranceData);
	    if (res.infcode === 0) {
	      this.addProgressDetail('医保数据上传成功', 'success');
	      this.progressStep3Desc = '上传成功';
	      
	      // 调用addInfYB接口记录日志
	      this.addProgressDetail('医保3505商品采购信息上传成功！正在记录日志信息中...');
	      
	      // 准备addInfYB接口参数
	      const userData = JSON.parse(localStorage.getItem('userInfo') || '{}');
	      const logParams = {
	        operationTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
	        tradingCode: res.msgid || `TR${dayjs().format('YYYYMMDDHHmmss')}`,
	        ifxType: 1, // 类型 1中药
	        fixmeDinsBchNo: this.rightForm.rxNo || '', // 流水号 / 处方编号
	        personNum: userData.staffId || '', // 人员编号id
	        settlementId: this.rightForm.id || '', // 结算ID / id
	        smtSerialNum: this.rightForm.patientId || '', // 就诊id/ 健康id
	        status: 1 // 1有效
	      };
	      
	      // 调用addInfYB接口
	      const logResult = await addInfYB(logParams);
	      
	      if (logResult.code === 200) {
	        this.addProgressDetail('日志信息保存成功！', 'success');
	      } else {
	        this.addProgressDetail(`日志信息保存失败: ${logResult.message}`, 'warning');
	      }
	      
	      // 设置3秒后自动刷新
	      this.timer = setTimeout(() => {
	        this.loadData();
	      }, 3000);
	      
	    } else {
	      this.addProgressDetail(`医保数据上传失败: ${res.err_msg}`, 'error');
	      this.progressStep3Desc = '上传失败';
	      this.progressHasError = true;
	    }
	    
	  } catch (error) {
	    this.addProgressDetail(`医保接口调用异常: ${error.message}`, 'error');
	    this.progressStep3Desc = '上传异常';
	    this.progressHasError = true;
	  }
	},
	
	// 刷新表格数据
	async refreshTableData() {
	  try {
	    this.addProgressDetail('正在更新表格数据...', 'info');
	    
	    // 重新加载左侧表格数据
	    await this.loadData();
	    
	    // 清空当前右侧表单和表格数据
	    this.rightForm = {
	      "age": 0,
	      "agnterCretno": "",
	      "agnterName": "",
	      "cardId": "",
	      "deptName": "",
	      "fullName": "",
	      "westernDiagnos": "",
	      "id": 0,
	      "name": "",
	      "patientId": 0,
	      "remark": "",
	      "rxName": "",
	      "rxNo": 0,
	      "saleAmt": 0,
	      "sex": 0,
	      "skintstRx": 0,
	      "state": 0,
	      "voList": []
	    };
	    this.rightTableData = [];
	    
	    // 清空搜索条件
	    this.form.healthId = '';
	    this.form.prescriptionSearch = '';
	    this.form.name = '';
	    
	    // 强制重新计算合计行
	    this.$nextTick(() => {
	      this.$refs.rightTable?.doLayout();
	    });
	    
	    this.addProgressDetail('表格数据更新完成', 'success');
	    
	  } catch (error) {
	    console.error('刷新表格数据失败:', error);
	    this.addProgressDetail('表格数据更新失败', 'error');
	  }
	},
	
	// 第一步：检查追溯码
	async checkTraceCodes() {
	  this.progressStep = 1;
	  this.progressStep1Desc = '检查中...';
	  
	  // 检查是否有强制追溯码药品未采集
	  const hasUncollected = this.rightTableData.some(item => 
	    item.drugTracB === 1 && (!item.drgTracCode || item.drgTracCode === '')
	  );
	  
	  if (hasUncollected) {
	    this.addProgressDetail('存在强制追溯码药品未采集，请先完成采集', 'error');
	    throw new Error('存在强制追溯码药品未采集');
	  }
	  
	  // 检查已采集的追溯码
	  const traceCodeItems = this.rightTableData.filter(item => 
	    item.drugTracB === 1 && item.drgTracCode && item.drgTracCode !== ''
	  );
	  
	  if (traceCodeItems.length > 0) {
	    this.addProgressDetail(`已录入 ${traceCodeItems.length} 个药品的追溯码`, 'success');
	    this.progressStep1Desc = '追溯码已录入完成';
	  } else {
	    this.addProgressDetail('无强制追溯码药品需要录入', 'info');
	    this.progressStep1Desc = '无追溯码需要录入';
	  }
	  
	  // 模拟检查耗时
	  await new Promise(resolve => setTimeout(resolve, 500));
	},
	
	// 第二步：执行发药
	async executeMedicineDispensing() {
	  this.progressStep = 2;
	  this.progressStep2Desc = '执行中...';
	  
	  try {
	    // 准备发药数据 - 确保所有必要字段都有值
	    const sendData = {
	      id: this.rightForm.id, // 处方ID
	      voList: this.rightTableData.map(item => {
	        // 构建每个药品的发药数据
	        const medicineData = {
	          id: item.id || item.rdDetailsId, // 明细ID，兼容不同字段名
	          drgTracCnt: Number(item.drgTracCnt) || 0,
	          drgTracCode: item.drgTracCode || '',
	          drugTracB: Number(item.drugTracB) || 0,
	          drugTracMaxCnt: Number(item.drugTracMaxCnt) || 0,
	          drugTracMaxId: Number(item.drugTracMaxId) || 0,
	          drugTracMinId: Number(item.drugTracMinId) || 0,
	          // 添加其他必要字段
	          cnt: Number(item.cnt) || 0,
	          purcPric: Number(item.purcPric) || 0,
	          saleAmt: Number(item.saleAmt) || 0
	        };
	        
	        // 打印调试信息
	        console.log('药品发药数据:', medicineData);
	        return medicineData;
	      })
	    };
	    
	    // 打印完整的发药数据
	    console.log('完整发药数据:', sendData);
	    
	    this.addProgressDetail('开始调用发药接口...', 'info');
	    
	    // 调用发药接口
	    let res = await fyZYSave(sendData);
	    if (res.code === 200) {
	      this.addProgressDetail('发药成功', 'success');
	      this.progressStep2Desc = '发药完成';
	      
	      // 返回发药结果和用户信息
	      return { 
	        success: true, 
	        data: res.data,
	        isInsurance: this.checkUserInsuranceStatus()
	      };
	    } else {
	      this.addProgressDetail(`发药失败: ${res.message}`, 'error');
	      this.progressStep2Desc = '发药失败';
	      return { success: false, message: res.message };
	    }
	    
	  } catch (error) {
	    this.addProgressDetail(`发药接口调用异常: ${error.message}`, 'error');
	    this.progressStep2Desc = '发药异常';
	    return { success: false, message: error.message };
	  }
	},
	// 新增：验证发药数据完整性
	validateSendData(sendData) {
	  if (!sendData.id) {
	    throw new Error('处方ID不能为空');
	  }
	  
	  if (!sendData.voList || sendData.voList.length === 0) {
	    throw new Error('发药药品列表不能为空');
	  }
	  
	  // 检查每个药品的必要字段
	  for (let i = 0; i < sendData.voList.length; i++) {
	    const item = sendData.voList[i];
	    
	    if (!item.id) {
	      throw new Error(`第${i + 1}个药品缺少明细ID`);
	    }
	    
	    if (item.drugTracB === 1 && !item.drgTracCode) {
	      throw new Error(`药品 ${item.name || '未知'} 需要追溯码但未提供`);
	    }
	    
	    if (item.cnt <= 0) {
	      throw new Error(`药品 ${item.name || '未知'} 的数量必须大于0`);
	    }
	  }
	  
	  return true;
	},
	// 检查用户医保状态
	checkUserInsuranceStatus() {
	  try {
	    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
	    return userInfo.isInsurance === 1; // 返回true/false
	  } catch (error) {
	    console.error('获取用户医保状态失败:', error);
	    return false;
	  }
	},
	
	// 新增：医保3505接口方法
	// async toYb3505(insuranceData) {
	//   // 1. 准备医保3505接口参数
	//   // 2. 引入ybapi，设置正确的请求头：customHeaders
	//   // 3. 引入ybapi，设置正确的请求体：requestBody
	//   // 4. 打印拼接设置好的请求参数
	//   // 5. 开始调用医保相关接口
	//   // 6. 打印医保接口响应
	//   // 7. 成功 / 失败 设置步骤进度条
	// },
	// 新增：医保3505接口方法
	async toYb3505(insuranceData) {
	  try {
	    this.addProgressDetail('开始准备医保3505接口数据...', 'info');
	    
	    // 1. 准备医保3505接口参数
	    const requestBody = this.prepareYb3505RequestBody(insuranceData);
	    
	    // 2. 先调用addYbRquestData接口
	    this.addProgressDetail('调用addYbRquestData接口准备医保数据...', 'info');
	    
	    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
	    const newItem = {
	      infno: 3505,
	      mdtrtareaAdmvs: userInfo.mdtrtareaAdmvs || '',
	      data: JSON.stringify(requestBody),
	      patientId: userInfo.userId || '',
	      patientName: userInfo.username || ''
	    };
	    
	    const ybRequestRes = await addYbRquestData(newItem);
	    
	    if (ybRequestRes.code !== 200) {
	      throw new Error('医保数据准备失败: ' + ybRequestRes.message);
	    }
	    
	    this.addProgressDetail('医保数据准备完成，开始设置请求头...', 'info');
	    
	    let responseData = ybRequestRes.data;
	    if (typeof responseData === 'string') {
	      try {
	        responseData = JSON.parse(responseData);
	      } catch (parseError) {
	        throw new Error('解析医保响应数据失败');
	      }
	    }
	    
	    // 3. 生成医保标准请求头
	    const headers = this.generateYbHeaders(responseData);
	    
	    // 4. 打印请求参数（调试用）
	    console.log('医保3505接口请求参数:', requestBody);
	    
	    // 5. 开始调用医保相关接口
	    this.addProgressDetail('开始调用医保3505接口...', 'info');
	    
	    // 6. 调用医保接口
	    const res = await sendYbRequest(requestBody, headers);
	    
	    // 7. 打印医保接口响应
	    console.log('医保3505接口响应:', res);
	    
	    // 8. 处理响应结果
	    if (res.infcode === 0) {
	      this.addProgressDetail('医保数据上传成功' + res.output.result.exp_content, 'success');
	      this.progressStep3Desc = '上传成功';
	      
	      // 设置3秒后自动刷新
	      this.timer = setTimeout(() => {
	        this.loadData();
	      }, 3000);
	      
	      return res;
	    } else {
	      this.addProgressDetail(`医保数据上传失败: ${res.err_msg}`, 'error');
	      this.progressStep3Desc = '上传失败';
	      this.progressHasError = true;
	      return res;
	    }
	    
	  } catch (error) {
	    console.error('医保3505接口调用异常:', error);
	    this.addProgressDetail(`医保接口调用异常: ${error.message}`, 'error');
	    this.progressStep3Desc = '上传异常';
	    this.progressHasError = true;
	    throw error;
	  }
	},
	
	// 准备医保3505请求体 84176725733439158107
	prepareYb3505RequestBody(insuranceData) {
	  // 按照右边接口文档格式构建请求体
	  const userData = JSON.parse(localStorage.getItem('userInfo') || '{}');
	  
	  const requestBody = {
	    // 头部信息
	    infno: '3505', // 接口编号
	    msgid: `${userData.clinicCode || '000000'}${dayjs().format('YYYYMMDDHHmmss')}${this.getRandom4Digits()}`,
	    mdtrtarea_admvs: userData.mdtrtareaAdmvs || '', // 就医地医保区划
	    insuplc_admdvs: userData.mdtrtareaAdmvs || '', // 参保地医保区划
	    recer_sys_code: '007', // 接收方系统代码
	    dev_no: '', // 设备号
	    fixmedins_code: userData.clinicCode || '', // 医药机构编号
	    fixmedins_name: userData.clinicName || '', // 医药机构名称
	    inf_time: dayjs().format('YYYY-MM-DD HH:mm:ss'), // 入参时间
	    infver: 'V1.0', // 接口版本
	    opter: userData.userId || '', // 操作员
	    opter_name: userData.staffName || '', // 操作员姓名
	    opter_type: '1', // 操作员类型
	    recer_admdvs: userData.mdtrtareaAdmvs || '', // 接收方医保区划
	    sign_no: this.generateSignNo(), // 签到流水号
	    signtype: 'SM3', // 签名类型
	    cainfo: '', // CA信息
	    dev_safe_info: '', // 设备安全信息
	    
	    // 主体信息 - 直接使用selinfo节点，取消sel_list
	    input: {
	      selinfo: this.prepareSelInfo(insuranceData) // 销售信息主体
	    }
	  };
	  
	  return requestBody;
	},
	
	// 修改：准备input数据（按照左边截图格式）
	prepareInputData(insuranceData) {
	  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
	  
	  return {
	    // 销售信息主体
	    selinfo: {
	      // 基本信息
	      fixmedins_code: this.rightForm.fixmedins_code || '',
	      fixmedins_name: this.rightForm.fixmedins_name || '',
	      
	      // 销售信息
	      sel_list: this.prepareSelList(insuranceData.medicineList),
	      
	      // 时间信息
	      sel_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
	      acpt_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
	      
	      // 人员信息
	      psn_no: insuranceData.patientInfo.patientId || '',
	      psn_name: insuranceData.patientInfo.name || '',
	      psn_cert_type: '01', // 证件类型：身份证
	      certno: insuranceData.patientInfo.cardId || '',
	      
	      // 业务信息
	      sel_plc: this.form.dispensingWindow || '', // 销售地点
	      bilg_opt: this.rightForm.fullName || userInfo.username || '', // 开单医师
	      bilg_dept: this.rightForm.deptName || '', // 开单科室
	      
	      // 医保信息
	      mdtrt_id: insuranceData.patientInfo.mdtrtId || '', // 就诊ID
	      med_type: insuranceData.patientInfo.medType || '', // 医疗类别
	      setl_id: insuranceData.patientInfo.setlId || '', // 结算ID
	      
	      // 金额信息
	      tota_amt: this.rightForm.saleAmt || 0, // 总金额
	      acct_amt: this.rightForm.saleAmt || 0, // 账户金额
	      psn_part_amt: 0, // 个人自付
	      fund_part_amt: this.rightForm.saleAmt || 0 // 基金支付
	    }
	  };
	},
	
	// 修改：生成医保请求头（按照左边截图格式）
	generateYbHeaders(responseData) {
	  // 从addYbRquestData的响应中获取必要的头信息
	  const {
	    infosyscode = '',
	    signature = '',
	    hsfNonce = '',
	    hsfTimestamp = Date.now().toString()
	  } = responseData;
	  
	  // 获取用户和机构信息
	  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
	  const clinicInfo = JSON.parse(localStorage.getItem('clinicInfo') || '{}');
	  
	  // 构建完整的请求头
	  return {
	    'Content-Type': 'application/json;charset=UTF-8',
	    'infosyscode': infosyscode || clinicInfo.infosyscode || process.env.VUE_APP_INFOSYS_CODE || '',
	    'hsf_signature': signature || this.generateSignature(hsfTimestamp),
	    'fixmedins_code': userInfo.clinicCode || '',
	    'hsf_nonce': hsfNonce || this.generateNonce(),
	    'hsf_timestamp': hsfTimestamp,
	    'opter': userInfo.userId || '',
	    'opter_name': userInfo.username || '',
	    'mdtrtarea_admvs': userInfo.mdtrtareaAdmvs || '',
	    'recer_sys_code': '007',
	    'infver': 'V1.0',
	    'inf_time': dayjs().format('YYYY-MM-DD HH:mm:ss'),
	    'Authorization': localStorage.getItem('token') || ''
	  };
	},

	// 修改：准备销售信息(selinfo节点) - 根据rightForm和voList中的数据取值
	prepareSelInfo(insuranceData) {
	  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
	  
	  // 获取第一个药品信息（如果有）
	  const firstMedicine = this.rightTableData.length > 0 ? this.rightTableData[0] : {};
	  
	  return {
	    // 基本信息
	    fixmedins_code: userInfo.clinicCode || '',
	    fixmedins_name: userInfo.clinicName || '',
	    
	    // 销售信息 - 取消sel_list节点，将关键信息放在顶层
	    med_list_codg: firstMedicine.medListCodg || '', // 医疗目录编码
	    fixmedins_hilist_id: userInfo.clinicCode || '', // 定点医药机构目录编号
	    fixmedins_hilist_name: userInfo.clinicName || '', // 定点医药机构目录名称
	    fixmedins_bchno: this.rightForm.id || '', // 定点医药机构批次流水号
	    
	    // 人员信息
	    prsc_dr_cert_type: this.rightForm.prsc_dr_cert_type || '01', // 开方医师证件类型
	    prsc_dr_certno: this.rightForm.prsc_dr_certno || '', // 开方医师证件号码
	    prsc_dr_name: this.rightForm.fullName || '', // 开方医师姓名
	    phar_cert_type: this.rightForm.phar_cert_type || '01', // 药师证件类型
	    phar_certno: this.rightForm.phar_certno || '', // 药师证件号码
	    phar_name: userInfo.staffName || '', // 药师姓名
	    phar_prac_cert_no: this.rightForm.phar_prac_cert_no || '', // 药师执业资格证号
	    
	    // 患者信息
	    psn_no: this.rightForm.patientId?.toString() || '', // 人员编号
	    psn_cert_type: '01', // 人员证件类型
	    certno: this.rightForm.cardId || '', // 证件号码
	    psn_name: this.rightForm.name || '', // 人员姓名
	    
	    // 药品信息 - 使用第一个药品的信息
	    drug_name: firstMedicine.name || '', // 药品名称
	    drug_spec: firstMedicine.drugSpec || '', // 药品规格
	    manu_lotnum: firstMedicine.manuLotnum || '', // 生产批号
	    manu_date: firstMedicine.manuDate || '', // 生产日期
	    expy_end: firstMedicine.expyDate || '', // 有效期
	    
	    // 业务信息
	    rx_flag: this.rightForm.rx_flag || '1', // 处方药标志
	    trdn_flag: this.rightForm.trdn_flag || '0', // 拆零标志
	    finl_trns_pric: firstMedicine.purcPric?.toString() || '0', // 最终成交单价
	    rxno: this.rightForm.rxNo?.toString() || '', // 处方号
	    rx_circ_flag: this.rightForm.rx_circ_flag || '0', // 外购处方标志
	    rtal_docno: this.rightForm.id || '', // 零售单据号
	    stoout_no: this.rightForm.stoout_no || '', // 销售出库单据号
	    bchno: this.rightForm.bchno || '', // 批次号
	    
	    // 销售信息
	    pric: firstMedicine.purcPric?.toString() || '0', // 单价
	    cnt: firstMedicine.cnt?.toString() || '0', // 数量
	    amt: firstMedicine.saleAmt?.toString() || '0', // 金额
	    pac_cnt: firstMedicine.pacCnt?.toString() || '1', // 包装数量
	    
	    // 时间信息
	    sel_time: dayjs().format('YYYY-MM-DD HH:mm:ss'), // 销售时间
	    acpt_time: dayjs().format('YYYY-MM-DD HH:mm:ss'), // 接收时间
	    
	    // 地点信息
	    sel_plc: this.form.dispensingWindow || '', // 销售地点
	    bilg_opt: this.rightForm.fullName || '', // 开单医师
	    bilg_dept: this.rightForm.deptName || '', // 开单科室
	    
	    // 医保信息
	    hi_feesetl_type: this.rightForm.hi_feesetl_type || '1', // 医保费用结算类型
	    setl_id: this.rightForm.setl_id || '', // 结算ID
	    mdtrt_sn: firstMedicine.rxId || '', // 就医流水号
	    mdtrt_id: this.rightForm.mdtrt_id || '', // 就诊ID
	    med_type: this.rightForm.med_type || '', // 医疗类别
	    
	    // 金额信息
	    tota_amt: this.rightForm.saleAmt?.toString() || '0', // 总金额
	    acct_amt: this.rightForm.saleAmt?.toString() || '0', // 账户金额
	    psn_part_amt: '0', // 个人自付
	    fund_part_amt: this.rightForm.saleAmt?.toString() || '0', // 基金支付
	    
	    // 追溯码信息
	    drug_trac_codg: firstMedicine.drgTracCode || '', // 药品追溯码
	    drug_prod_barc: firstMedicine.drug_prod_barc || '', // 药品条形码
	    shelf_posi: firstMedicine.shelf_posi || '', // 货架位
	    
	    // 销售/退货信息
	    sel_retn_cnt: firstMedicine.cnt?.toString() || '0', // 销售/退货数量
	    sel_retn_time: dayjs().format('YYYY-MM-DD HH:mm:ss'), // 销售/退货时间
	    sel_retn_opter_name: userInfo.staffName || '', // 销售/退货经办人姓名
	    
	    // 其他信息
	    memo: this.rightForm.remark || '', // 备注
	    mdtrt_setl_type: this.rightForm.mdtrt_setl_type || '1' // 就诊结算类型
	  };
	},

	
	// 准备销售明细列表(sel_list节点)
	prepareSelList(medicineList) {
	  return medicineList.map((item, index) => ({
		sel_list_sn: (index + 1).toString(), // 销售明细流水号
		med_list_codg: item.medListCodg || '', // 医疗目录编码
		medins_list_codg: item.medinsListCodg || '', // 医药机构目录编码
		drug_name: item.name || '', // 药品名称
		drug_spec: item.drugSpec || '', // 药品规格
		pric: item.price || 0, // 单价
		cnt: item.quantity || 0, // 数量
		amt: item.amount || 0, // 金额
		pac_cnt: item.packageCount || 1, // 包装数量
		manu_date: item.manuDate, // 生产日期
		expy_date: item.expyDate, // 有效期至
		manu_lotnum: item.manuLotnum || '', // 批号
		prodentp_name: item.prodentpName || '', // 生产企业名称
		
		// 追溯码信息
		drug_trac_codg: item.traceCode || '', // 药品追溯码
		drug_trac_cnt: item.drgTracCnt || 1, // 药品追溯码数量
	  }));
	},
	
	// 准备药品追溯信息
	prepareDrugTracInfo() {
	  const traceCodes = this.rightTableData
		.filter(item => item.drgTracCode && item.drgTracCode.trim() !== '')
		.map(item => item.drgTracCode);
	  
	  return traceCodes.map((code, index) => ({
		drug_trac_sn: (index + 1).toString(), // 药品追溯流水号
		drug_trac_codg: code, // 药品追溯码
		drug_trac_cnt: 1, // 药品追溯码数量
		associa_sellist_sn: (index + 1).toString(), // 关联销售明细流水号
	  }));
	},
	
	// 新增：生成签到流水号方法
	generateSignNo() {
	  const timestamp = dayjs().format('YYYYMMDDHHmmss');
	  const randomNum = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
	  return `S${timestamp}${randomNum}`;
	},
	// 生成签名(增强实现)
	generateSignature(timestamp) {
	  try {
	    // 获取必要的签名参数
	    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
	    const clinicInfo = JSON.parse(localStorage.getItem('clinicInfo') || '{}');
	    
	    // 构建签名字符串（根据医保局要求）
	    const signString = `${timestamp}${clinicInfo.clinicCode || ''}${userInfo.userId || ''}${this.rightForm.rxNo || ''}`;
	    
	    // 这里应该使用实际的签名算法（如SM2/SM3）
	    // 由于浏览器环境限制，这里使用btoa作为示例
	    // 实际项目中应该使用后端提供的签名服务或前端加密库
	    return btoa(encodeURIComponent(signString));
	  } catch (error) {
	    console.error('生成签名失败:', error);
	    // 返回默认签名
	    return `sign_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
	  }
	},
	
	// 生成随机数（增强实现）
	generateNonce() {
	  // 生成更安全的随机数
	  const array = new Uint32Array(4);
	  window.crypto.getRandomValues(array);
	  return Array.from(array, dec => dec.toString(16).padStart(8, '0')).join('');
	},
	
	// 生成消息ID
	// 生成消息ID（增强实现）
		generateMsgId() {
		  const timestamp = dayjs().format('YYYYMMDDHHmmss');
		  const clinicInfo = JSON.parse(localStorage.getItem('clinicInfo') || '{}');
		  const randomNum = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
		  
		  return `${clinicInfo.clinicCode || '000000'}${timestamp}${randomNum}`;
		},
		
		// 获取4位随机数
		getRandom4Digits() {
			return Math.floor(1000 + Math.random() * 9000).toString();
		},
		// 处理进度完成
		handleProgressComplete() {
		  this.progressDialogVisible = false;
		  
		  // 如果是非医保用户，确保数据已经刷新
		  if (!this.checkUserInsuranceStatus()) {
		    this.$message.success('发药流程已完成');
		  }
		},
		// 准备医保上传数据
		prepareInsuranceData() {
		  // 这里根据实际业务需求准备医保上传数据
		  return {
		    businessType: '3505',
		    patientInfo: {
		      name: this.rightForm.name,
		      cardId: this.rightForm.cardId,
		      patientId: this.rightForm.patientId
		    },
		    prescriptionInfo: {
		      rxNo: this.rightForm.rxNo,
		      rxName: this.rightForm.rxName,
		      totalAmount: this.rightForm.saleAmt
		    },
		    medicineList: this.rightTableData.map(item => ({
		      name: item.name,
		      drugSpec: item.drugSpec,
		      quantity: item.cnt,
		      unit: item.unt,
		      price: item.purcPric,
		      amount: item.saleAmt,
		      traceCode: item.drgTracCode || ''
		    })),
		    traceCodes: this.rightTableData
		      .filter(item => item.drgTracCode && item.drgTracCode !== '')
		      .map(item => item.drgTracCode)
		  };
		},
		
		// 添加进度详情
		addProgressDetail(message, type = 'info') {
		  this.progressDetails.push({
		    message,
		    type,
		    time: new Date().toLocaleTimeString()
		  });
		  
		  // 保持滚动到底部
		  this.$nextTick(() => {
		    const container = this.$el.querySelector('.details-content');
		    if (container) {
		      container.scrollTop = container.scrollHeight;
		    }
		  });
		},
		
		// 修改 getDataValue 方法
		getDataValue(row) {
		  console.log('双击行数据:', row);
		  
		  // 深拷贝数据，避免引用问题
		  this.rightForm = JSON.parse(JSON.stringify(row));
		  
		  // 确保 voList 存在且是数组
		  if (row.voList && Array.isArray(row.voList)) {
		    // 处理 voList 中的每个药品项，确保数值类型正确
		    this.rightTableData = row.voList.map(item => ({
		      ...item,
		      drugTracB: item.drugTracB || 0,
		      purcAmt: Number(item.purcAmt) || 0,
		      cnt: Number(item.cnt) || 0,
		      purcPric: Number(item.purcPric) || 0,
		      saleAmt: Number(item.saleAmt) || 0,
		      // 确保追溯码相关字段有默认值
		      drgTracCode: item.drgTracCode || '',
		      drgTracCnt: Number(item.drgTracCnt) || 0,
		      // 其他可能需要的数值字段
		      drugTracMaxCnt: Number(item.drugTracMaxCnt) || 0,
		      drugTracMaxId: Number(item.drugTracMaxId) || 0,
		      drugTracMinId: Number(item.drugTracMinId) || 0
		    }));
		  } else {
		    this.rightTableData = [];
		    console.warn('行数据中没有 voList 或 voList 不是数组');
		  }
		  
		  // 强制重新计算合计行
		  this.$nextTick(() => {
		    if (this.$refs.rightTable) {
		      this.$refs.rightTable.doLayout();
		    }
		  });
		},
			
		// 切换药品列表显示
		toggleMedicineList() {
		  this.showMedicineList = !this.showMedicineList;
		  
		  // 添加平滑展开/收起动画
		  this.$nextTick(() => {
			const listElement = this.$el.querySelector('.medicine-list');
			if (listElement) {
			  listElement.style.transition = 'max-height 0.3s ease';
			  listElement.style.overflow = 'hidden';
			  
			  if (this.showMedicineList) {
				listElement.style.maxHeight = '0';
				setTimeout(() => {
				  listElement.style.maxHeight = listElement.scrollHeight + 'px';
				}, 10);
			  } else {
				listElement.style.maxHeight = listElement.scrollHeight + 'px';
				setTimeout(() => {
				  listElement.style.maxHeight = '0';
				}, 10);
			  }
			}
		  });
		},
	
		  // 发药按钮点击事件
		  async sendMedic() {
		    // 检查是否有患者信息
		    if (!this.rightForm.patientId || !this.rightForm.name) {
		      this.$message.warning('暂未查询到患者诊断信息');
		      return;
		    }
		    
		    // 检查是否有强制追溯码的药品
		    const hasMandatoryTraceDrugs = this.rightTableData.some(item => item.drugTracB === 1);
		    
		    // 设置发药对话框数据时初始化药品列表
		    this.sendMedicineData = {
		      patientName: this.rightForm.name,
		      diagnosis: this.rightForm.westernDiagnos,
		      traceCodeCount: this.calculateTraceCodeCount(),
		      medicineCount: this.calculateMedicineCount(),
		      printTogether: false
		    };
		    
		    // 根据是否有强制追溯码药品决定是否展开
		    this.showMedicineList = hasMandatoryTraceDrugs;
		    
		    // 加载药品数据
		    this.loadWesternMedicines();
		    
		    // 显示发药对话框
		    this.sendMedicineDialogVisible = true;
		  },
	
		// 加载中药数据 - 添加默认值避免报错
		loadWesternMedicines() {
		  this.westernMedicines = this.rightTableData.map(item => ({
			...item,
			// 确保drugTracB有默认值
			drugTracB: item.drugTracB || 0,
			traceCodeCollected: false // 初始化为未采集状态
		  }));
		},
		
		// 计算已采集的追溯码数量
		calculateTraceCodeCount() {
		    return this.rightTableData.reduce((count, item) => {
		      // 只计算强制追溯码且已采集的药品
		      if (item.drugTracB === 1 && item.traceCodeCollected) {
		        return count + (item.drgTracCnt || 1);
		      }
		      return count;
		    }, 0);
		},
		
		// 计算药品数量
		calculateMedicineCount() {
		  // 根据实际业务逻辑计算
		  return this.rightTableData.length || 0;
		},
		
		// 打开追溯码采集对话框
		openTraceCodeDialog() {
		    this.traceCodeDialogVisible = true;
		    
		    // 转换药品数据为追溯码表格格式
		    this.traceCodeTableData = this.transformToTraceCodeData(this.westernMedicines);
		},
		
		// 打开扫码对话框
		openScanDialog(item) {
		  this.currentScanItem = item;
		  this.scanInput = '';
		  this.scanDialogVisible = true;
		  
		  // 自动聚焦输入框
		  this.$nextTick(() => {
			this.$refs.scanInput?.focus();
		  });
		},
		
		// 处理扫码输入
		handleScanInput() {
		    if (!this.scanInput || !this.currentScanItem) return;
		    
		    // 验证追溯码格式 (示例：至少7位数字)
		    if (!/^\d{7,}$/.test(this.scanInput)) {
		      this.$message.error('追溯码格式不正确，请输入至少7位数字');
		      return;
		    }
		    
		    // 提取追溯码前7位
		    this.traceCodePrefix = this.scanInput.substring(0, 7);
		    
		    // 在rightTableData中查找匹配的药品
		    this.findMatchingMedicines();
		},
	
		// 查找匹配的药品
		findMatchingMedicines() {
		    this.matchedMedicines = [];
		      
		    // 检查当前处方是否有药品数据
		    if (!this.rightTableData || this.rightTableData.length === 0) {
		      this.$message.warning('当前处方无药品信息');
		      return;
		    }
		      
		    // 遍历rightTableData查找匹配的药品
		    this.rightTableData.forEach(item => {
		      // 确保drugTracMaxId是字符串类型
		      const maxId = String(item.drugTracMaxId || '');
		          
		      // 检查追溯码前缀是否匹配
		      if (maxId === this.traceCodePrefix) {
		        this.matchedMedicines.push({
		          ...item, // 包含药品完整信息
		          traceId: this.traceCodePrefix,  // 追溯标识码
		          fullTraceCode: this.scanInput   // 完整追溯码
		        });
		      }
		    });
		      
		    if (this.matchedMedicines.length === 0) {
		      this.$message.error(`未找到匹配的药品信息，追溯码前缀: ${this.traceCodePrefix}`);
		    } else {
		      this.$message.success(`找到${this.matchedMedicines.length}个匹配的药品`);
			  console.log(this.matchedMedicines,'找到${this.matchedMedicines.length}个匹配的药品');
		    }
		},
	
		// 在扫码对话框中确认绑定追溯码
		async confirmTraceCode() {
		  if (!this.currentScanItem || this.matchedMedicines.length === 0) {
		    this.$message.warning('请先扫描有效的追溯码');
		    return;
		  }
		  
		  const scanInput = this.scanInput;
		  
		  // 更新匹配到的药品的追溯码信息
		  this.matchedMedicines.forEach(medicine => {
		    // 更新追溯码和数量
		    medicine.drgTracCode = scanInput;
		    medicine.drgTracCnt = medicine.drgTracCnt ? medicine.drgTracCnt + 1 : 1;
		    
		    // 标记为已采集
		    medicine.traceCodeCollected = true;
		    
		    // 更新追溯码表格数据
		    this.updateTraceCodeTableData(medicine);
		    
		    // 更新右侧表格数据
		    this.updateRightTableData(medicine);
		    
		    // 修复：确保更新 westernMedicines 中的对应项
		    const index = this.westernMedicines.findIndex(item => item.drugId === medicine.drugId);
		    if (index !== -1) {
		      // 使用 Vue.set 确保响应性
		      this.$set(this.westernMedicines, index, {
		        ...this.westernMedicines[index],
		        drgTracCode: scanInput,
		        drgTracCnt: medicine.drgTracCnt,
		        traceCodeCollected: true
		      });
		    }
		  });
		  
		  this.$message.success('追溯码绑定成功');
		  this.scanDialogVisible = false;
		  
		  // 更新发药对话框中的追溯码数量
		  this.sendMedicineData.traceCodeCount = this.calculateTraceCodeCount();
		},
		
		// 更新追溯码表格数据
		  updateTraceCodeTableData(medicine) {
		    const index = this.traceCodeTableData.findIndex(
		      item => item.rawData && item.rawData.drugId === medicine.drugId
		    );
		    
		    if (index !== -1) {
		      const updatedItem = {
		        ...this.traceCodeTableData[index],
		        drgTracCode: medicine.drgTracCode,
		        drgTracCnt: medicine.drgTracCnt,
		        sendStatus: '已关联'
		      };
		      
		      this.$set(this.traceCodeTableData, index, updatedItem);
		    }
		  },
		  
		  // 更新右侧表格数据
		updateRightTableData(medicine) {
		  const index = this.rightTableData.findIndex(
			item => item.drugId === medicine.drugId
		  );
		  
		  if (index !== -1) {
			this.$set(this.rightTableData, index, {...medicine});
		  }
		},
			
		// 更新药品状态
		updateMedicineStatus() {
		    // 检查是否所有强制追溯码药品都已采集
		    const allCollected = this.westernMedicines.every(item => 
		      item.drugTracB !== 1 || item.traceCodeCollected
		    );
		    
		    if (allCollected) {
		      this.$message.success('所有强制追溯码药品已完成采集');
		    }
		},
			
		// 确认发药
		async confirmSendMedicine() {
		  this.sendMedicineDialogVisible = false;
		  
		  // 检查是否有强制追溯码药品未采集
		  const hasUncollected = this.rightTableData.some(item => 
		    item.drugTracB === 1 && (!item.drgTracCode || item.drgTracCode === '')
		  );
		  
		  if (hasUncollected) {
		    this.$message.error('存在强制追溯码药品未采集，请先完成采集');
		    return;
		  }
		  
		  // 使用新的进度流程
		  await this.startSendMedicineProcess();
		},
		
		// 将药品数据转换为追溯码表格数据
		transformToTraceCodeData(medicineList) {
		    return medicineList.map(item => {
		      return {
		        medicineName: `${item.name} ${item.drugSpec}`,
		        productCode: item.prodentpName || '未知厂家',
		        sendStatus: '未关联',
		        sendCombo: `${item.cnt}${item.unt}`,
		        drgTracCnt: '0',
		        drgTracCode: '',
		        rawData: item // 保留原始数据以便后续操作
		      };
		    });
		},
	
		// 完成追溯码采集
		completeTraceCode() {
	      // 检查是否所有强制追溯码药品都已采集
	      const allCollected = this.traceCodeTableData.every(item => {
	        // 只需要检查强制追溯码药品
	        if (item.rawData && item.rawData.drugTracB === 1) {
	          return !!item.drgTracCode && item.drgTracCode.trim() !== '';
	        }
	        return true; // 非强制追溯码药品直接通过
	      });
	      
	      if (!allCollected) {
	        this.$message.error('请先完成所有强制追溯码药品的采集');
	        return;
	      }
	    
	      // 更新rightTableData中的追溯码信息
	      this.rightTableData = this.rightTableData.map(item => {
	        const traceItem = this.traceCodeTableData.find(t => 
	          t.rawData && t.rawData.drugId === item.drugId
	        );
	        if (traceItem) {
	          return {
	            ...item,
	            drgTracCode: traceItem.drgTracCode,
	            drgTracCnt: traceItem.drgTracCnt,
	            traceCodeCollected: true // 确保设置采集状态
	          };
	        }
	        return item;
	      });
	    
	      // 更新发药对话框中的药品状态
	      this.westernMedicines = this.westernMedicines.map(item => {
	        const updatedItem = {...item};
	        
	        // 更新状态 - 强制追溯码药品
	        if (item.drugTracB === 1) {
	          // 检查是否已采集追溯码
	          const traceItem = this.traceCodeTableData.find(t => 
	            t.rawData && t.rawData.drugId === item.drugId
	          );
	          
	          if (traceItem && traceItem.drgTracCode) {
	            updatedItem.traceCodeCollected = true;
	          }
	        }
	        
	        return updatedItem;
	      });
	    
	      // 强制更新视图
	      this.$forceUpdate();
	    
	      this.traceCodeDialogVisible = false;
	      this.$message.success('追溯码采集完成');
	      
	      // 重新打开发药对话框
	      this.sendMedicineDialogVisible = true;
	    },
		
		// 打印收据
		async printReceipt() {
		  try {
			// 调用打印接口
			await this.$print.executePrint();
			this.$message.success('打印成功');
		  } catch (error) {
			console.error('打印失败:', error);
			this.$message.error('打印失败');
		  }
		},
		
		// 关闭对话框处理
		handleSendMedicineClose(done) {
		  this.$confirm('确认取消发药？', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		  }).then(() => {
			done();
			this.$message.info('已取消发药');
		  }).catch(() => {});
		},
		
		handleTraceCodeClose(done) {
		  this.$confirm('确认关闭追溯码采集？', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		  }).then(() => {
			done();
			// 重新打开发药对话框
			this.sendMedicineDialogVisible = true;
		  }).catch(() => {});
		},
		
		setAllButtonsLoading(isLoading) {
		    this.loading = isLoading;
		    // 设置所有按钮的加载状态
		    for (let key in this.buttonLoading) {
		      this.buttonLoading[key] = isLoading;
		    }
		  },
		  
		// 格式化货币金额
		formatCurrency(value) {
		  if (value === null || value === undefined || value === '') {
		    return '￥0';
		  }
		  
		  const num = Number(value);
		  if (isNaN(num)) {
		    return '￥0';
		  }
		  
		  return `￥${num}`;
		},
		
		// 获取状态文本
		getStatusText(state) {
		  return this.statusMap[state] || '未知状态';
		},
		
		// 获取状态标签类型
		getStatusType(state) {
		  switch(state) {
			case 0: return 'info';
			case 1: return 'primary';
			case 2: return 'warning';
			case 3: return 'success';
			case 4: return 'danger';
			default: return 'info';
		  }
		},
		
		// 添加合计行计算方法
	    getSummaries(param) {
	      const { columns, data } = param;
	      const sums = [];
	      
	      columns.forEach((column, index) => {
	        if (index === 0) {
	          sums[index] = '合计';
	          return;
	        }
	        
	        // 只对金额和数量列进行合计
	        if (column.property === 'purcPric' || column.property === 'cnt' || column.property === 'saleAmt') {
	          const values = data.map(item => {
	            // 确保数据是数字类型
	            const value = Number(item[column.property]);
	            return isNaN(value) ? 0 : value;
	          });
	          
	          // 计算合计值
	          const sum = values.reduce((prev, curr) => prev + curr, 0);
	          
	          // 金额保留2位小数
	          sums[index] = column.property === 'purcPric' || column.property === 'saleAmt' ? sum: sum;
	        } else {
	          sums[index] = '';
	        }
	      });
	    
	      return sums;
	    },
	    
	    calculateTableHeights() {
	      // 计算左侧表格高度
	      const leftFormHeight = document.querySelector('.left-form')?.offsetHeight || 200;
	      const leftPaginationHeight = 40; // 分页组件高度
	      const leftTableHeight = window.innerHeight - 50 - 50 - leftFormHeight - leftPaginationHeight - 30; // 减去header、bottom、form、分页高度以及padding
	      this.leftTableHeight = Math.max(200, leftTableHeight) + 'px';
	      
	      // 计算右侧表格高度
	      const rightDescriptionsHeight = document.querySelector('.right-descriptions')?.offsetHeight || 200;
	      const rightTableHeight = window.innerHeight - 50 - 50 - rightDescriptionsHeight - 30; // 减去header、bottom、描述列表高度以及padding
	      this.rightTableHeight = Math.max(200, rightTableHeight) + 'px';
	    }
	  }
	}
	</script>
	
	<style lang="less" scoped>
		/* 添加合计行样式 */
		/deep/ .el-table__footer-wrapper .el-table__footer .cell {
		  font-weight: bold;
		  color: #aa0000;
		}
		
		/* 完成发药对话框样式 */
		.send-medicine-dialog /deep/ .el-dialog__header {
		  border-bottom: 1px solid #e8e8e8;
		  padding: 16px 20px;
		}
		
		/deep/ .el-link{
			justify-content:left;
		}
		.send-medicine-dialog /deep/ .el-dialog__body {
		  padding: 20px;
		}
		
		.send-medicine-content {
		  border: 1px solid #dcdfe6;
		  border-radius: 4px;
		  padding: 16px;
		  .medicine-list {
			max-height: 0;
			overflow: hidden;
			transition: max-height 0.3s ease;
			
			&.expanded {
			  max-height: 500px; /* 根据实际内容高度调整 */
			}
		  }
		}
		
		.info-item {
		  display: flex;
		  margin-bottom: 12px;
		  align-items: flex-start;
		}
		
		.info-item:last-child {
		  margin-bottom: 0;
		}
		
		.label {
		  width: 80px;
		  color: #606266;
		  font-weight: 500;
		}
		
		.value {
		  flex: 1;
		  color: #303133;
		}
		
		.medicine-content {
		  display: flex;
		  flex-direction: column;
		  gap: 8px;
		}
		
		.trace-code-link {
		  font-size: 14px;
		}
		
		.medicine-type {
		  color: #606266;
		  font-size: 14px;
		}
		
		.dialog-footer {
		  display: flex;
		  justify-content: space-between;
		  align-items: center;
		  margin-top: 20px;
		  padding-top: 16px;
		  border-top: 1px solid #e8e8e8;
		}
		
		.footer-buttons {
		  display: flex;
		  gap: 12px;
		}
		
		/* 追溯码采集对话框样式 */
		.trace-code-dialog /deep/ .el-dialog__body {
		  padding: 20px;
		}
		
		.important-reminder {
		  background: #fff6e6;
		  border: 1px solid #ffd591;
		  border-radius: 4px;
		  padding: 12px;
		  margin-bottom: 16px;
		}
		
		.reminder-header {
		  display: flex;
		  align-items: center;
		  margin-bottom: 8px;
		  color: #d46b08;
		  font-weight: 500;
		}
		
		.reminder-header i {
		  margin-right: 8px;
		}
		
		.reminder-content p {
		  margin: 4px 0;
		  color: #d46b08;
		  font-size: 13px;
		  line-height: 1.5;
		}
		
		.scan-input-area {
		  margin-bottom: 16px;
		}
		
		.trace-code-input {
		  margin-bottom: 8px;
		}
		
		.input-tips {
		  display: flex;
		  gap: 16px;
		  font-size: 13px;
		}
		
		.trace-code-table /deep/ .el-table__cell {
		  padding: 8px 0;
		}
		
		.no-trace-code {
		  color: #909399;
		  font-style: italic;
		}
		
		.trace-code-footer {
		  display: flex;
		  justify-content: flex-end;
		  gap: 12px;
		}
		
		/* 右侧描述列表样式 */
		.right-descriptions {
		  padding: 10px;
		  border-bottom: 1px solid #e6e6e6;
		  overflow-y: auto;
		  flex-shrink: 0;
		  
		  .custom-descriptions {
			font-size: 12px !important;
			
			/deep/ .el-descriptions__label {
			  font-weight: 500;
			  color: #606266;
			}
			
			/deep/ .el-descriptions__content {
			  color: #303133;
			}
			
			.remark-text {
			  color: #909399;
			  font-style: italic;
			}
		  }
		}
		
		.send-medici-container {
		  width: 100%;
		  height: calc(100vh - 120px);
		  padding: 12px;
		  display: flex;
		  flex-direction: column;
		  background-color: #f5f5f5;
		  overflow: hidden;
		  
		  .send-medici-header {
			height: 50px;
			background-color: #409EFF;
			color: white;
			display: flex;
			align-items: center;
			padding: 0 20px;
			flex-shrink: 0;
			
			h4 {
			  margin: 0;
			  font-size: 16px;
			  font-weight: normal;
			}
		  }
		  
		  .send-medici-main {
			flex: 1;
			display: flex;
			overflow: hidden;
			
			.send-medici-left {
			  width: 20%;
			  height: 100%;
			  display: flex;
			  flex-direction: column;
			  border-right: 1px solid #e6e6e6;
			  background-color: white;
			  overflow: hidden;
			  
			  .left-form {
				padding: 10px;
				border-bottom: 1px solid #e6e6e6;
				overflow-y: auto;
				flex-shrink: 0;
				
				.el-form-item {
				  margin-bottom: 10px;
				  
				  .form-item-row {
					display: flex;
					align-items: center;
					width: 100%;
					
					.form-label {
					  width: 58px;
					  text-align: left;
					  padding-right: 10px;
					  color: #606266;
					  font-size: 12px;
					}
					
					.el-select, .el-input {
					  flex: 1;
					  min-width: 88px;
					}
					
					.el-button {
					  padding: 6px 8px;
					  min-width: 36px;
					}
				  }
				}
			  }
			  
			  .left-table-container {
				flex: 1;
				display: flex;
				flex-direction: column;
				overflow: hidden;
				
				.left-table {
				  flex: 1;
				  overflow: auto;
				}
				
				.left-pagination {
				  padding: 10px;
				  border-top: 1px solid #e6e6e6;
				  background-color: #fff;
				  flex-shrink: 0;
				  
				  /deep/ .el-pagination {
					justify-content: center;
				  }
				}
			  }
			}
			
			.send-medici-right {
			  width: 80%;
			  height: 100%;
			  display: flex;
			  flex-direction: column;
			  background-color: white;
			  overflow: hidden;
			  
			  .right-table-container {
				flex: 1;
				display: flex;
				flex-direction: column;
				overflow: hidden;
				padding: 10px;
				
				.right-table {
				  flex: 1;
				  overflow: auto;
				  
				  /deep/ .el-table__body-wrapper {
					overflow-x: auto;
					overflow-y: auto;
				  }
				}
			  }
			}
		  }
		  
		  .send-medici-bottom {
			height: 50px;
			background-color: white;
			border-top: 1px solid #e6e6e6;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 20px;
			flex-shrink: 0;
			
			.bottom-left, .bottom-right {
			  display: flex;
			  align-items: center;
			}
			
			.el-button[disabled] {
			  opacity: 0.6;
			}
		  }
		}
	</style>